export function buildInternalAdminSearchUrl (
  internalAdminBaseUrl = process.vars.INTERNAL_ADMIN_URL
) {
  const base = (internalAdminBaseUrl || '').replace(/\/$/, '')
  return `${base}/assignment-terms/search`
}

export function buildInternalAdminVendorProductUrl (
  vendorId,
  productId,
  atId,
  internalAdminBaseUrl = process.vars.INTERNAL_ADMIN_URL
) {
  const base = (internalAdminBaseUrl || '').replace(/\/$/, '')
  const path = `${base}/assignment-terms/vendor/${encodeURIComponent(vendorId)}/product/${encodeURIComponent(productId)}`
  if (atId === undefined || atId === null || atId === '') {
    return path
  }
  return `${path}?at_id=${encodeURIComponent(atId)}`
}
